import { PageMessage } from "@/common/typography";

export default function _404() {
    return <PageMessage>Page not found.</PageMessage>;
}
